import { type Account, type Customer } from "@/app/master";
import { nameOptions } from "@/app/queries";
import type { Errors } from "@/app/useDraft";
import { Field, Form, Combobox } from "@/ui";
import { PriceFields } from "./PriceFields";
import type { PriceDraft } from "./priceDraft";

interface Props { draft: PriceDraft; errors: Errors<PriceDraft>; set: <K extends keyof PriceDraft>(k: K, v: PriceDraft[K]) => void; accounts?: Account[]; customers?: Customer[] }

/** 售价表单的字段，见 docs/03 3.8。币种固定为客户的账单币种（D115）。 */
export function PriceForm({ draft, errors, set, accounts, customers }: Props) {
  const onCustomer = (v: string) => {
    set("customer_id", v);
    set("account_id", "");
    const c = customers?.find((x) => String(x.id) === v);
    if (c) { set("currency", c.currency); set("charge_on", c.charge_on); }
  };
  return (
    <Form columns={2}>
      <Field label="客户" required error={errors.customer_id}>
        <Combobox block searchPlaceholder="搜索客户名称或 ID" options={nameOptions(customers)} value={draft.customer_id || null} onChange={onCustomer} placeholder="选择客户" invalid={!!errors.customer_id} />
      </Field>
      <Field label="账号" required error={errors.account_id}>
        <Combobox block searchPlaceholder="搜索账号名称或 system_id" options={nameOptions(accounts?.filter((a) => String(a.customer_id) === draft.customer_id), customers)} value={draft.account_id || null} onChange={(v) => set("account_id", v)} disabled={!draft.customer_id} placeholder="选择账号" invalid={!!errors.account_id} />
      </Field>
      <PriceFields currencyReadOnly idPrefix="p" draft={draft} errors={errors} set={set} />
    </Form>
  );
}
